import { render, staticRenderFns } from "./RegisterForms.vue?vue&type=template&id=5b129da4"
import script from "./RegisterForms.vue?vue&type=script&lang=js"
export * from "./RegisterForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports